import sideSelect from './sideSelect.vue'
export default sideSelect
